<script lang="ts" setup>
export interface ShareButtonsLink {
    icon: string
    url: string
    label: string
}
export interface ShareButtonsLinkProps {
    data: ShareButtonsLink
}

const props = defineProps<ShareButtonsLinkProps>()
</script>
<template>
  <a
    :href="props.data.url"
    rel="nofollow noopener noreferrer"
    :aria-label="props.data.label"
    target="_blank"
    class="share-buttons-link rounded-circle d-flex align-items-center justify-content-center box-shadow-2"
    :data-cy="`share_button_${props.data.icon}`"
  >
    <svg
      aria-hidden="true"
      class="d-block text-secondary"
      width="24"
      height="24"
    >
      <use :xlink:href="`#${props.data.icon}`" />
    </svg>
  </a>
</template>
<style lang="scss">
@import './ShareButtonsLink.scss';
</style>
